export const GET_CONTENT_TYPES = "GET_CONTENT_TYPES";
export const RESET_CONTENT_TYPES = "RESET_CONTENT_TYPES";
export const SET_CONTENT_TYPES_REQUEST_STATUS = "SET_CONTENT_TYPES_REQUEST_STATUS";
